/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SecurityDashboardLayoutResponse
 */
export interface SecurityDashboardLayoutResponse {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof SecurityDashboardLayoutResponse
     */
    layout?: { [key: string]: any; };
    /**
     * 
     * @type {Date}
     * @memberof SecurityDashboardLayoutResponse
     */
    updatedAt?: Date;
}

/**
 * Check if a given object implements the SecurityDashboardLayoutResponse interface.
 */
export function instanceOfSecurityDashboardLayoutResponse(value: object): value is SecurityDashboardLayoutResponse {
    return true;
}

export function SecurityDashboardLayoutResponseFromJSON(json: any): SecurityDashboardLayoutResponse {
    return SecurityDashboardLayoutResponseFromJSONTyped(json, false);
}

export function SecurityDashboardLayoutResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecurityDashboardLayoutResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'layout': json['layout'] == null ? undefined : json['layout'],
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
    };
}

export function SecurityDashboardLayoutResponseToJSON(json: any): SecurityDashboardLayoutResponse {
    return SecurityDashboardLayoutResponseToJSONTyped(json, false);
}

export function SecurityDashboardLayoutResponseToJSONTyped(value?: SecurityDashboardLayoutResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'layout': value['layout'],
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
    };
}

